import { useState, useEffect } from 'react';
import { GetConvention } from '../../../api/home.js';
import { useQuery } from '@tanstack/react-query';
import { PromoCard } from '../../../components/Cards/promos-card/promo-card';
import './conference.scss';

export default function Conference() {
  const [promosData, setPromosData] = useState([]);

  const getConventionQuery = useQuery({
    queryKey: ['getConventionQuery'],
    queryFn: async () => JSON.parse(await GetConvention()()),
  });

  useEffect(() => {
    if (getConventionQuery.isSuccess && getConventionQuery.data) {
      setPromosData(getConventionQuery.data);
    }
  }, [getConventionQuery.isSuccess, getConventionQuery.data]);

  return (
    <>
      {getConventionQuery.isLoading || promosData.length == 0 ? (
        <></>
      ) : (
        <PromoCard
          className="col-12 mb-[3%]"
          media={'/CmsImages/' + promosData[0].Image}
          imageLocation="cover"
          textLocation="center"
          backgroundColor={
            promosData[0].BackgroundColor ? promosData[0].BackgroundColor : undefined
          }
          heading={promosData[0].Header ? promosData[0].Header : undefined}
          subHeading={promosData[0].SubHeader ? promosData[0].SubHeader : undefined}
          description={promosData[0].Description ? promosData[0].Description : undefined}
          textColor={promosData[0].TextColor ? promosData[0].TextColor : undefined}
          subTextcolor={promosData[0].SubTextColor ? promosData[0].SubTextColor : undefined}
          link={promosData[0].Link}
          linkType={promosData[0].LinkTypeID}
        />
      )}
    </>
  );
}
